import styled from 'styled-components';
import { space, SpaceProps, ColorProps, color } from 'styled-system';

export const StyledCard = styled.div<SpaceProps & ColorProps>`
  width: 100%;
  position: relative;
  padding: 14px;
  direction: rtl;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  border-radius: ${({ theme }): string => theme.radii.xxl};
  background-color: ${({ theme }): string => theme.colors.secondaryBackground};
  ${space}
  ${color}
`;
